import { makeRequest } from 'utils/requestLogger';

export default (liveID) =>
  makeRequest('get', `/api/live_discussions/${liveID}/auth/agoraRtcScreen/`);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/getAgoraRTCconnectionScreen.js